import React, { createContext, useContext, useEffect, useState } from 'react';
import { shopApi } from '../utils/shopApi';

const ShopAdminAuthContext = createContext(null);

export const ShopAdminAuthProvider = ({ children }) => {
  const [staff, setStaff] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('shop_admin_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMe = async () => {
      if (!token) { setLoading(false); return; }
      try {
        const r = await shopApi.get('/shop/staff/me');
        setStaff(r.data);
      } catch {
        localStorage.removeItem('shop_admin_token');
        setToken(null);
      } finally {
        setLoading(false);
      }
    };
    fetchMe();
  }, [token]);

  const login = async (email, password) => {
    const r = await shopApi.post('/shop/staff/login', { email, password });
    localStorage.setItem('shop_admin_token', r.data.access_token);
    setToken(r.data.access_token);
    setStaff(r.data.staff);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem('shop_admin_token');
    setToken(null);
    setStaff(null);
  };

  const hasPerm = (key) => {
    if (!staff) return false;
    if (staff.role === 'admin') return true;
    return !!(staff.permissions || {})[key];
  };

  return (
    <ShopAdminAuthContext.Provider value={{ staff, token, loading, login, logout, hasPerm }}>
      {children}
    </ShopAdminAuthContext.Provider>
  );
};

export const useShopAdminAuth = () => {
  const ctx = useContext(ShopAdminAuthContext);
  if (!ctx) throw new Error('useShopAdminAuth must be used inside ShopAdminAuthProvider');
  return ctx;
};
